<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar">
			<span class="h-panel-title">销售数据</span>
			 <div class="hbtnbox">
					<button class="h-btn h-btn-blue" v-if="tabShow==2" @click="exportExcelCommunity()">导出社区销售数据</button>
					<button class="h-btn h-btn-blue" v-if="tabShow==1" @click="exportExcelDepart()">导出按组别/部门销售数据</button>
					<button class="h-btn h-btn-blue" v-if="tabShow==1" @click="exportExcelPerson()">导出按销售人员销售数据</button>
					<!-- <button class="h-btn">打印</button> -->
			</div>
		</div>

		<div class="tabsbox">
			<a-tabs default-active-key="1" @change="callback" size="large"  :animated="false">
				<a-tab-pane key="1" tab="按社区" v-if="tabShow==2">
				</a-tab-pane>
				<a-tab-pane key="2" tab="按组别/部门" v-if="tabShow==1">
				</a-tab-pane>
				<a-tab-pane key="3" tab="按销售人员" v-if="tabShow==1">
				</a-tab-pane>
				<a-tab-pane key="4" tab="按门店" v-if="tabShow==4">
				</a-tab-pane>
			</a-tabs>
		</div>	

		<div v-show="datakey==1">

			<!-- <div class="timeselectbox">年度选择：
				<span  v-for="(item,index) in sqyeararr" :key="index" :class="sqcuron==index ? 'active':''" @click="selectsqyear(item,index)">{{item}}年</span>
			</div> -->
			<div class="filterbox">
				<div class="filtertimebox">
					<a-radio-group :value="size01" @change="changeday001" style="font-weight:normal">					
						<a-radio-button value="thismonth">
							本月
						</a-radio-button>
						<a-radio-button value="lastmonth">
							上月
						</a-radio-button>
						<a-radio-button value="whole">
							全部
						</a-radio-button>
					</a-radio-group>
				</div>	

				<div class="filterdatebox">
					日期选择：<a-range-picker :locale="locale"  @change="onChange001" />
				</div> 
				<a-button type="primary" style="margin-left:20px;" @click="gosearchCommunity">
					查询
				</a-button> 
			</div>	

			<div class="databox">
				
					<dl>
						<dt>
							销售额
						</dt>
						<dd>{{CommunityTallydata.orderAmountSum}}</dd>
					</dl>
				
					<dl>
						<dt>
							订单量
						</dt>
						<dd>{{CommunityTallydata.orderCnt}}</dd>
					</dl>	

					<dl>
						<dt>
							佣金总金额
						</dt>
						<dd>{{CommunityTallydata.rebateAmountSum ? CommunityTallydata.rebateAmountSum : '0' }}</dd>
					</dl>


					<dl>
						<dt>
							合伙人分佣
						</dt>
						<dd>{{CommunityTallydata.regionAmountSum?CommunityTallydata.regionAmountSum:'0'}}</dd>
					</dl>

					<dl>
						<dt>
							销售人员分佣
						</dt>
						<dd>{{CommunityTallydata.saleAmountSum ? CommunityTallydata.saleAmountSum : '0' }}</dd>
					</dl>

				

				</div>


				<div class="tablebox">

					<a-table :columns="columns" :data-source="CommunityData" :pagination="false"  :scroll="{ x: 1500, y: 610 }">
						<a slot="action" slot-scope="text">action</a>
					</a-table>

				</div>


		</div>


		<div v-show="datakey==2">
			
			<div class="filterbox">
				<div class="filtertimebox">
					<a-radio-group :value="size" @change="changeday" style="font-weight:normal">					
						<a-radio-button value="thismonth">
							本月
						</a-radio-button>
						<a-radio-button value="lastmonth">
							上月
						</a-radio-button>
						<a-radio-button value="whole">
							全部
						</a-radio-button>
					</a-radio-group>
				</div>	

				<div class="filterdatebox">
					日期选择：<a-range-picker :locale="locale"  @change="onChange" />
				</div>

				<div>
					<span style="padding-left:20px;font-weight:normal;padding-right:15px;">部门/组别</span>
					<a-select :value="dqdepss" style="width: 120px" @change="selectdep">
						<a-select-option v-for="(item, index) in depparam" :key="index" :value="item.departId">
							{{ item.title }}
						</a-select-option>
					</a-select>
				</div>	

				<a-button type="primary" style="margin-left:20px;" @click="gosearch">
					查询
				</a-button>

			</div>	

			<div class="databox">
				
					<dl>
						<dt>
							销售额
						</dt>
						<dd>{{GroupTallydata.orderAmountSum}}</dd>
					</dl>
				
					<dl>
						<dt>
							订单量
						</dt>
						<dd>{{GroupTallydata.orderCnt}}</dd>
					</dl>	

					<dl>
						<dt>
							佣金总金额
						</dt>
						<dd>{{GroupTallydata.rebateAmountSum?GroupTallydata.rebateAmountSum:'0'}}</dd>
					</dl>
					<dl>
						<dt>
							合伙人分佣
						</dt>
						<dd>{{GroupTallydata.regionAmountSum?GroupTallydata.regionAmountSum:'0'}}</dd>
					</dl>
					<dl>
						<dt>
							销售人员分佣
						</dt>
						<dd>{{GroupTallydata.saleAmountSum ? GroupTallydata.saleAmountSum : '0' }}</dd>
					</dl>
				

				</div>


			<div class="tablebox">

					<a-table :columns="columns02" :data-source="data02" :pagination="false" :scroll="{ x: 1500, y: 610 }">
						<a slot="action" slot-scope="text">action</a>
					</a-table>

			</div>




		</div>


		<div v-show="datakey==3">
			
			<div class="filterbox">
				<div class="filtertimebox">
					<a-radio-group :value="size03" @change="changeday03" style="font-weight:normal">					
						<a-radio-button value="thismonth">
							本月
						</a-radio-button>
						<a-radio-button value="lastmonth">
							上月
						</a-radio-button>
						<a-radio-button value="whole">
							全部
						</a-radio-button>
					</a-radio-group>
				</div>	

				<div class="filterdatebox">
					日期选择：<a-range-picker :locale="locale"  @change="onChange03" />
				</div>

				<div>
					<span style="padding-left:20px;font-weight:normal;padding-right:15px;">部门/组别</span>
					<a-select :value="dqdepss" style="width: 120px" @change="selectdep03">
						<a-select-option v-for="(item, index) in depparam" :key="index" :value="item.departId">
							{{ item.title }}
						</a-select-option>
					</a-select>
				</div>	

				<a-button type="primary" style="margin-left:20px;" @click="gosearch03">
					查询
				</a-button>

			</div>	


			<div class="databox">
				
					<dl>
						<dt>
							销售额
						</dt>
						<dd>{{Persondata.orderAmountSum}}</dd>
					</dl>
				
					<dl>
						<dt>
							订单量
						</dt>
						<dd>{{Persondata.orderCnt}}</dd>
					</dl>	

					<dl>
						<dt>
							佣金总金额
						</dt>
						<dd>{{Persondata.rebateAmountSum?Persondata.rebateAmountSum:'0'}}</dd>
					</dl>

					<dl>
						<dt>
							销售人员分佣
						</dt>
						<dd>{{Persondata.saleAmountSum ? Persondata.saleAmountSum : '0' }}</dd>
					</dl>
				

				</div>


			<div class="tablebox">

					<a-table :columns="columns03" :data-source="data03" :pagination="false"  :scroll="{ x: 1500, y: 610 }">
						<a slot="action" slot-scope="text">action</a>
					</a-table>

			</div>




		</div>

		<div v-show="datakey==4">

			<!-- <div class="timeselectbox">年度选择：
				<span  v-for="(item,index) in sqyeararr" :key="index" :class="sqcuron==index ? 'active':''" @click="selectsqyear(item,index)">{{item}}年</span>
			</div> -->
			<div class="filterbox">
				<div class="filtertimebox">
					<a-radio-group :value="size04" @change="changeday004" style="font-weight:normal">					
						<a-radio-button value="thismonth">
							本月
						</a-radio-button>
						<a-radio-button value="lastmonth">
							上月
						</a-radio-button>
						<a-radio-button value="whole">
							全部
						</a-radio-button>
					</a-radio-group>
				</div>	

				<div class="filterdatebox">
					日期选择：<a-range-picker :locale="locale"  @change="onChange004" />
				</div> 
				<a-button type="primary" style="margin-left:20px;" @click="goSearchStore">
					查询
				</a-button> 
			</div>	

			<div class="databox">
				
					<dl>
						<dt>
							销售额
						</dt>
						<dd>{{storeTallydata.orderAmount ? storeTallydata.orderAmount  :'0'}}</dd>
					</dl>
				
					<dl>
						<dt>
							订单量
						</dt>
						<dd>{{storeTallydata.orderCnt? storeTallydata.orderCnt  :'0'}}</dd>
					</dl>	

					<dl>
						<dt>
							在线支付
						</dt>
						<dd>{{storeTallydata.payCash ? storeTallydata.payCash : '0' }}</dd>
					</dl>


					<dl>
						<dt>
							余额支付
						</dt>
						<dd>{{storeTallydata.payBalance?storeTallydata.payBalance:'0'}}</dd>
					</dl>

					<dl>
						<dt>
							消费金支付
						</dt>
						<dd>{{storeTallydata.payConsume ? storeTallydata.payConsume : '0' }}</dd>
					</dl>
					<dl>
						<dt>
							商家余额支付
						</dt>
						<dd>{{storeTallydata.payStoreBalance ? storeTallydata.payStoreBalance : '0' }}</dd>
					</dl>

				

				</div>


				<div class="tablebox">

					<a-table :columns="columns04" :data-source="storeData" :pagination="false"  :scroll="{ x: 1500, y: 610 }">
						<a slot="action" slot-scope="text">action</a>
					</a-table>

				</div>


		</div>


	</div>
</template>

<script>

	const columns = [
		{ title: '时间', width: 300, dataIndex: 'timeCycle', key: 'timeCycle', fixed: 'left' },
		{ title: '社区', width: 300, dataIndex: 'communityName', key: 'communityName', fixed: 'left',align:'center' },
		{ title: '销售金额' , dataIndex: 'orderAmountSum', key: 'orderAmountSum',  align:'center' },
		{ title: '订单数', dataIndex: 'orderCnt', key: 'orderCnt' ,align:'center'},
		{ title: '佣金总金额', dataIndex: 'rebateAmountSum', key: 'rebateAmountSum'  ,align:'center'},
		{ title: '社区合伙人分润', dataIndex: 'regionAmountSum', key: 'regionAmountSum' ,align:'center' },
		{ title: '团队分佣', dataIndex: 'teamAmountSum', key: 'teamAmountSum' ,align:'center' },
		{ title: '销售人员分佣', dataIndex: 'saleAmountSum', key: 'saleAmountSum'  ,align:'center'}
	];


	const columns02 = [
		{ title: '销售周期', width: 300, dataIndex: 'timeCycle', key: 'timeCycle', fixed: 'left' },
		{ title: '部门/组别', width: 100, dataIndex: 'departName', key: 'departName', fixed: 'left',align:'center' },
		{ title: '销售金额', dataIndex: 'orderAmountSum', key: 'orderAmountSum', width: 150 ,align:'center'},
		{ title: '订单数', dataIndex: 'orderCnt', key: 'orderCnt', width: 150 ,align:'center'},
		{ title: '佣金总金额', dataIndex: 'rebateAmountSum', key: 'rebateAmountSum', width: 150,align:'center' },
		{ title: '社区合伙人分润', dataIndex: 'regionAmountSum', key: 'regionAmountSum', width: 150 ,align:'center' },
		{ title: '团队分佣', dataIndex: 'teamAmountSum', key: 'teamAmountSum', width: 150 ,align:'center'},
		{ title: '销售人员分润', dataIndex: 'saleAmountSum', key: 'saleAmountSum', width: 150 ,align:'center'}
	];


	const columns03 = [
		{ title: '销售周期', width: 300, dataIndex: 'timeCycle', key: 'timeCycle', fixed: 'left' },
		{ title: '销售人员', width: 100, dataIndex: 'personName', key: 'personName', fixed: 'left',align:'center' },
		{ title: '职位角色', dataIndex: 'postName', key: 'postName', width: 150 ,align:'center'},
		{ title: '部门/组别', dataIndex: 'departName', key: 'departName', width: 150 ,align:'center'},
		{ title: '销售金额', dataIndex: 'orderAmountSum', key: 'orderAmountSum', width: 150,align:'center' },
		{ title: '订单数', dataIndex: 'orderCnt', key: 'orderCnt', width: 150 ,align:'center' },
		{ title: '佣金总金额', dataIndex: 'rebateAmountSum', key: 'rebateAmountSum', width: 150 ,align:'center'},
		{ title: '社区合伙人分润', dataIndex: 'regionAmountSum', key: 'regionAmountSum', width: 150 ,align:'center'},
		{ title: '团队分佣', dataIndex: 'teamAmountSum', key: 'teamAmountSum', width: 150 ,align:'center'},
		{ title: '销售人员分佣', dataIndex: 'saleAmountSum', key: 'saleAmountSum', width: 150 ,align:'center'}
	];
	const columns04 = [
		{ title: '时间', width: 300, dataIndex: 'timeCycle', key: 'timeCycle', fixed: 'left' },
		{ title: '门店', width: 300, dataIndex: 'storeName', key: 'storeName', fixed: 'left',align:'center' },
		{ title: '销售金额' , dataIndex: 'orderAmount', key: 'orderAmount',  align:'center' },
		{ title: '订单数', dataIndex: 'orderCnt', key: 'orderCnt' ,align:'center'},
		{ title: '在线支付金额', dataIndex: 'payCash', key: 'payCash'  ,align:'center'},
		{ title: '余额支付金额', dataIndex: 'payBalance', key: 'payBalance' ,align:'center' },
		{ title: '消费金支付金额', dataIndex: 'payConsume', key: 'payConsume' ,align:'center' },
		{ title: '商家余额支付金额', dataIndex: 'payStoreBalance', key: 'payStoreBalance'  ,align:'center'}
	];

	const data = [];

	const data02 = [];

	const data03 = [];

	const data04 = [];

	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	import moment from 'moment';
	import 'moment/locale/zh-cn';
	

	import { mapState } from 'vuex';
	export default {
		name: "Salarymanage",
		data() {
			return {
				dataList: {},
				data,
				tabShow:0,
				columns,
				columns02, //按部门组别
				sqyear:2023,
				sqyeararr:['2023','2024'],
				sqcuron:0,
				Tallydata:{},
				storeTallydata:{},
				datakey:4, //默认按门店
				size: 'whole',
				size01:'whole',
				size03: 'whole',
				size04: 'whole',
				locale,
				dqdepss:'',
				depparam:[],
				departmentlist:[], //部门
				selGroupTally:{
					accountSetsId:'',
					startTime:'',
					endTime:'',
					departId:''
				},
				selCommunityTally:{ 
					startTime:'',
					endTime:'' 
				},
				selStoreTally:{ 
					startTime:'',
					endTime:'' 
				},
				data02,
				CommunityData:[],
				storeData:[],
				CommunityTallydata:{},
				GroupTallydata:{}, 
				PersonTally:{
					accountSetsId:'',
					startTime:'',
					endTime:'',
					departId:''
				},
				summaryPersonparmas:{
					accountSetsId:'',
					startTime:'',
					endTime:'',
					departId:'',
					current:1,
					size:40
				},

				Persondata:{},
				data03,
				columns03,
				data04,
				columns04,
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			date() {
				return moment(this.accountDate);
			}
		},
		methods: {
			getsummaryRegionTally(){
				var accountSetsId = this.User.accountSetsId;
				var that = this;
				var parmas = {
					accountSetsId,
					year:this.sqyear
				}

				this.$api.salesdata.mallOrdersummaryRegionTally(parmas).then(res=>{				
					if(res.code==200){
						that.Tallydata = res.data
					}
					//console.log('9999',res);
				});	

			},
			getsummaryRegion(){
				var accountSetsId = this.User.accountSetsId;
				var that = this;
				var parmas = {
					accountSetsId,
					year:this.sqyear
				}
				this.$api.salesdata.mallOrdersummaryRegion(parmas).then(res=>{				
					if(res.code==200){
						that.data = res.data
					}					
				});	

			},
			//社区年份选择
			selectsqyear(year,index){
				//console.log('year',year);
				this.sqcuron = index;
				this.sqyear = year;
				this.getsummaryRegionTally();
				this.getsummaryRegion();

			},

			callback(e){

				this.datakey = e;
				if(e==1){
					this.changeday001(this.size01);
					this.gosearchCommunity();
				}
				else if(e==2){
					this.changeday01(this.size);
					this.getdepartment();
					this.getsummaryGroupTally();
					this.getsummaryGroup();

				}else if(e==3){
					
					this.changeday(this.size03);
					this.getdepartment();
					this.getsummaryPersonTally();
					this.getsummaryPerson();

				}else if (e==4){
					this.changeday004(this.size04);
					this.goSearchStore();
				}



			},
			//选择月份
			changeday(e){ 
				console.log(e);
				if(e.target){
					this.size = e.target.value;
					var value = e.target.value;
				}else{
					var value = e;
				}
				

				//获取完整的日期
				var date = new Date(); 
				//获取当前年份：
				var year = date.getFullYear(); 
				//获取当前月份：
				var month = date.getMonth() + 1;
				//获取当前日：
				var day = date.getDate();

				if(value=='thismonth'){
					month = (month > 9) ? month : ("0" + month);
					var time = this.getDay(0);
					var theday = year + "-" + month + "-" + '01';
					this.selGroupTally.startTime = theday;
					this.selGroupTally.endTime = time;

				}else if(value=='lastmonth'){
					this.selGroupTally.startTime = this.getLastMonthFirstDay();
					this.selGroupTally.endTime = this.getLastMonthAndDay();

				}else if(value=='whole'){

					this.selGroupTally.startTime = '';
					this.selGroupTally.endTime = this.getDay(0);

				}


				//按组别/部门
				this.getsummaryGroupTally();
				this.getsummaryGroup();


			},
			changeday01(e){
			//console.log('e',e.target.value);

				console.log(e);
				if(e.target){
					this.size = e.target.value;
					var value = e.target.value;
				}else{
					var value = e;
				}
				

				//获取完整的日期
				var date = new Date(); 
				//获取当前年份：
				var year = date.getFullYear(); 
				//获取当前月份：
				var month = date.getMonth() + 1;
				//获取当前日：
				var day = date.getDate();

				if(value=='thismonth'){
					month = (month > 9) ? month : ("0" + month);
					var time = this.getDay(0);
					var theday = year + "-" + month + "-" + '01';
					this.selGroupTally.startTime = theday;
					this.selGroupTally.endTime = time;

				}else if(value=='lastmonth'){
					this.selGroupTally.startTime = this.getLastMonthFirstDay();
					this.selGroupTally.endTime = this.getLastMonthAndDay();

				}else if(value=='whole'){

					this.selGroupTally.startTime = '';
					this.selGroupTally.endTime = this.getDay(0);

				}


				//按组别/部门

				this.getsummaryGroupTally();
				this.getsummaryGroup();


			},
			changeday001(e){
			//console.log('e',e.target.value);

				console.log(e);
				if(e.target){
					this.size = e.target.value;
					var value = e.target.value;
				}else{
					var value = e;
				}
				this.size01=value;

				//获取完整的日期
				var date = new Date(); 
				//获取当前年份：
				var year = date.getFullYear(); 
				//获取当前月份：
				var month = date.getMonth() + 1;
				//获取当前日：
				var day = date.getDate();

				if(value=='thismonth'){
					month = (month > 9) ? month : ("0" + month);
					var time = this.getDay(0);
					var theday = year + "-" + month + "-" + '01';
					this.selCommunityTally.startTime = theday;
					this.selCommunityTally.endTime = time;

				}else if(value=='lastmonth'){
					this.selCommunityTally.startTime = this.getLastMonthFirstDay();
					this.selCommunityTally.endTime = this.getLastMonthAndDay();

				}else if(value=='whole'){ 
					this.selCommunityTally.startTime = '';
					this.selCommunityTally.endTime = this.getDay(0);

				}
				//按社区
				this.gosearchCommunity(); 
			},
			changeday004(e){ 
 
				if(e.target){
					this.size = e.target.value;
					var value = e.target.value;
				}else{
					var value = e;
				}
				this.size04=value;

				//获取完整的日期
				var date = new Date(); 
				//获取当前年份：
				var year = date.getFullYear(); 
				//获取当前月份：
				var month = date.getMonth() + 1;
				//获取当前日：
				var day = date.getDate();

				if(value=='thismonth'){
					month = (month > 9) ? month : ("0" + month);
					var time = this.getDay(0);
					var theday = year + "-" + month + "-" + '01';
					this.selStoreTally.startTime = theday;
					this.selStoreTally.endTime = time;

				}else if(value=='lastmonth'){
					this.selStoreTally.startTime = this.getLastMonthFirstDay();
					this.selStoreTally.endTime = this.getLastMonthAndDay();

				}else if(value=='whole'){ 
					this.selStoreTally.startTime = '';
					this.selStoreTally.endTime = this.getDay(0);

				}
				//按门店
				this.goSearchStore(); 
			},
			//获取上个月第一天
			getLastMonthFirstDay() {
				var date = new Date();
				date.setDate(0);
				var y = date.getFullYear(); //获取年份
				var m = date.getMonth() + 1; //获取月份
				m = m < 10 ? "0" + m : m; //月份补 0
				return [y, m, '01'].join("-");
			},
			//获取上个月最后一天
			getLastMonthAndDay(){
				var nowDate = new Date();
				var year = nowDate.getFullYear();
				var month = nowDate.getMonth();
				if(month == 0){
					month = 12;
					year = year - 1;
				}
				var lastDay = new Date(year,month,0);
				month = month < 10 ? "0" + month : month;
				var yyyyMMdd = year+"-"+month+"-"+lastDay.getDate();
				return yyyyMMdd;
			},
			//获取某一天
			getDay(day) {
                var today = new Date();
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
                today.setTime(targetday_milliseconds); //注意，这行是关键代码                
                var tYear = today.getFullYear();
                var tMonth = today.getMonth();
                var tDate = today.getDate();
                tMonth = this.doHandleMonth(tMonth + 1);
                tDate = this.doHandleMonth(tDate);
                return tYear + "-" + tMonth + "-" + tDate;
            },
			doHandleMonth(month) {
                var m = month;
                if (month.toString().length == 1) {
                    m = "0" + month;
                };
                return m;
            },
			//按组别/部门-时间选择	
			onChange(date, dateString) {
				this.selGroupTally.startTime = dateString[0];
				this.selGroupTally.endTime = dateString[1];
				this.size = '';
				this.getsummaryGroupTally();
				this.getsummaryGroup();

			},
			onChange001(date, dateString) {
				this.selCommunityTally.startTime = dateString[0];
				this.selCommunityTally.endTime = dateString[1];
				this.size = '';
				this.gosearchCommunity();

			},
			onChange004(date, dateString) {
				this.selStoreTally.startTime = dateString[0];
				this.selStoreTally.endTime = dateString[1];
				this.size = '';
				this.goSearchStore();

			},

			//部门筛选
			selectdep(e, key) {

				var index = key.data.key;
				if (index > 0) {
					this.dqdepss = e;
					var departId = this.departmentlist[index - 1].id;
					this.selGroupTally.departId = departId;
				} else {
					this.selGroupTally.departId = '';
					this.dqdepss = '全部';
				}

			},
			//部门列表
			getdepartment() {
				var accountSetsId = this.User.accountSetsId;
				var that = this;
				this.$api.wages.department(accountSetsId).then(departdata => {
					//console.log('departdata', departdata);
					if (departdata.code == 200) {
						that.departmentlist = departdata.data;
						//param = [{ title: '全部', key: 0 }, { title: '选择1', key: 1 }, { title: '选择2', key: 2 }];
						var newarr = [{ title: '全部', key: 0 }];
						departdata.data.forEach(e => {
							var arrlist = {};
							arrlist.title = e.name;
							arrlist.key = e.code;
							arrlist.accountSetsId = e.accountSetsId;
							arrlist.departId = e.id;
							newarr.push(arrlist);
						});

						that.depparam = newarr;
						that.dqdepss = that.depparam[0].title;

					}
				})

			},	

			//按社区查询
			gosearchCommunity(){
				console.log("账套类型：" + this.User.accountSets.accountType);
				this.getsummaryCommunityTally();
				this.getsummaryCommunity();
			},
			getsummaryCommunityTally(){ 
				var selCommunityTally = this.selCommunityTally;  
				if(selCommunityTally.startTime=='' || selCommunityTally.endTime==''){
					var parmas = { };
				}else{
					var parmas = { 
						startTime:selCommunityTally.startTime,
						endTime:selCommunityTally.endTime 
					};
				};	

				var that = this;
				this.$api.salesdata.mallOrdersummaryCommunityTally(parmas).then(res=>{
					if(res.code==200){
						that.CommunityTallydata = res.data;
					}
				});

				
			},
			getsummaryCommunity(){

				var selCommunityTally = this.selCommunityTally; 

				if(selCommunityTally.startTime=='' || selCommunityTally.endTime==''){
					var parmas = {  
					};
				}else{
					var parmas = { 
						startTime:selCommunityTally.startTime,
						endTime:selCommunityTally.endTime 
					};
				};				

				var that = this;
				this.$api.salesdata.mallOrdersummaryCommunit(parmas).then(res=>{
					if(res.code==200){
						that.CommunityData = res.data
					}
				});



			},
			//按门店查询
			goSearchStore(){
				this.getsummaryStoreTally();
				this.getsummaryStore();
			},
			getsummaryStoreTally(){ 
				var selStoreTally = this.selStoreTally;  
				if(selStoreTally.startTime=='' || selStoreTally.endTime==''){
					var parmas = { };
				}else{
					var parmas = { 
						startTime:selStoreTally.startTime,
						endTime:selStoreTally.endTime 
					};
				};	

				var that = this;
				this.$api.salesdata.mallOrdersummaryStoreTally(parmas).then(res=>{
					if(res.code==200){
						that.storeTallydata = res.data;
					}
				});

				
			},
			getsummaryStore(){

				var selStoreTally = this.selStoreTally; 

				if(selStoreTally.startTime=='' || selStoreTally.endTime==''){
					var parmas = {  
					};
				}else{
					var parmas = { 
						startTime:selStoreTally.startTime,
						endTime:selStoreTally.endTime 
					};
				};				

				var that = this;
				this.$api.salesdata.mallOrderSummaryByStore(parmas).then(res=>{
					if(res.code==200){
						that.storeData = res.data
					}
				});
 
			},

			//按部门或组别查询
			gosearch(){

				//按部门或组别
				this.getsummaryGroupTally();
				this.getsummaryGroup();
			},	

			//按部门或组别
			getsummaryGroupTally(){
				
				var selGroupTally = this.selGroupTally;
				var accountSetsId = this.User.accountSetsId;

				if(selGroupTally.startTime=='' || selGroupTally.endTime==''){
					var parmas = {
						accountSetsId:accountSetsId,
						departId:selGroupTally.departId
					};
				}else{
					var parmas = {
						accountSetsId:accountSetsId,
						startTime:selGroupTally.startTime,
						endTime:selGroupTally.endTime,
						departId:selGroupTally.departId
					};
				};	

				var that = this;
				this.$api.salesdata.mallOrdersummaryGroupTally(parmas).then(res=>{
					if(res.code==200){
						that.GroupTallydata = res.data;
					}
				});

				
			},
			getsummaryGroup(){

				var selGroupTally = this.selGroupTally;
				var accountSetsId = this.User.accountSetsId;

				if(selGroupTally.startTime=='' || selGroupTally.endTime==''){
					var parmas = {
						accountSetsId:accountSetsId,
						departId:selGroupTally.departId
					};
				}else{
					var parmas = {
						accountSetsId:accountSetsId,
						startTime:selGroupTally.startTime,
						endTime:selGroupTally.endTime,
						departId:selGroupTally.departId
					};
				};				

				var that = this;
				this.$api.salesdata.mallOrdersummaryGroup(parmas).then(res=>{
					if(res.code==200){
						that.data02 = res.data
					}
				}); 
			},

			
			//选择月份
			changeday03(e){
			//console.log('e',e.target.value);
				
				if(e.target){
					this.size03 = e.target.value;
					var value = e.target.value;
				}else{
					var value = e;
				};			

				//获取完整的日期
				var date = new Date(); 
				//获取当前年份：
				var year = date.getFullYear(); 
				//获取当前月份：
				var month = date.getMonth() + 1;
				//获取当前日：
				var day = date.getDate();

				if(value=='thismonth'){
					month = (month > 9) ? month : ("0" + month);
					var time = this.getDay(0);
					var theday = year + "-" + month + "-" + '01';
					this.PersonTally.startTime = theday;
					this.PersonTally.endTime = time;

					this.summaryPersonparmas.startTime = theday;
					this.summaryPersonparmas.endTime = time;

				}else if(value=='lastmonth'){
					this.PersonTally.startTime = this.getLastMonthFirstDay();
					this.PersonTally.endTime = this.getLastMonthAndDay();

					this.summaryPersonparmas.startTime = this.getLastMonthFirstDay();
					this.summaryPersonparmas.endTime = this.getLastMonthAndDay();


				}else if(value=='whole'){

					this.PersonTally.startTime = '';
					this.PersonTally.endTime = '';

					this.summaryPersonparmas.startTime = '';
					this.summaryPersonparmas.endTime = '';

				};
				//按人员
				this.getsummaryPersonTally();
				this.getsummaryPerson();
			},

			//部门筛选
			selectdep03(e, key) {

				var index = key.data.key;
				if (index > 0) {
					this.dqdepss = e;
					var departId = this.departmentlist[index - 1].id;
					this.PersonTally.departId = departId;
					this.summaryPersonparmas.departId = departId;
				} else {
					this.PersonTally.departId = '';
					this.summaryPersonparmas.departId = '';
					this.dqdepss = '全部';
				}

			},

			//按人员
			onChange03(date, dateString) {
				this.PersonTally.startTime = dateString[0];
				this.PersonTally.endTime = dateString[1];

				this.summaryPersonparmas.startTime = dateString[0];
				this.summaryPersonparmas.endTime = dateString[1];

				this.size03 = '';
				this.getsummaryPersonTally();
				this.getsummaryPerson();

			},
			//按人员
			gosearch03(){
				//按部门或组别
				this.getsummaryPersonTally();
				this.getsummaryPerson();
			},	
 
			//按人员
			getsummaryPersonTally(){
				
				var PersonTally = this.PersonTally;
				var accountSetsId = this.User.accountSetsId;

				if(PersonTally.startTime=='' || PersonTally.endTime==''){
					var parmas = {
						accountSetsId:accountSetsId,
						accountType:1,
						departId:PersonTally.departId
					};
				}else{
					var parmas = {
						accountSetsId:accountSetsId,
						accountType:1,
						startTime:PersonTally.startTime,
						endTime:PersonTally.endTime,
						departId:PersonTally.departId
					};
				};	

				var that = this;
				this.$api.salesdata.mallOrdersummaryPersonTally(parmas).then(res=>{
					if(res.code==200){
						that.Persondata = res.data;
					}
				});

				
			},
			getsummaryPerson(){

				var PersonTally = this.PersonTally;

				var summaryPersonparmas = this.summaryPersonparmas;

				var accountSetsId = this.User.accountSetsId;

				if(PersonTally.startTime=='' || PersonTally.endTime==''){
					var parmas = {
						accountSetsId:accountSetsId,
						accountType:1,
						departId:PersonTally.departId,
						current:summaryPersonparmas.current,
						size:summaryPersonparmas.size
					};
				}else{
					var parmas = {
						accountSetsId:accountSetsId,
						accountType:1,
						startTime:PersonTally.startTime,
						endTime:PersonTally.endTime,
						departId:PersonTally.departId,
						current:summaryPersonparmas.current,
						size:summaryPersonparmas.size
					};
				};				

				var that = this;
				this.$api.salesdata.mallOrdersummaryPerson(parmas).then(res=>{
					if(res.code==200){
						that.data03 = res.data.records;
						that.summaryPersonparmas.size= res.data.size;
						that.summaryPersonparmas.current= res.data.current;
					}
				});



			},
			//导出
			exportExcelCommunity(){ 
				var selCommunityTally = this.selCommunityTally; 

				if(selCommunityTally.startTime=='' || selCommunityTally.endTime==''){
					var parmas = {  
					};
				}else{
					var parmas = { 
						startTime:selCommunityTally.startTime,
						endTime:selCommunityTally.endTime 
					};
				};				 
				this.$api.exportExcel.summaryDataCommunity(parmas).then(data => { 
						let objectUrl = window.URL.createObjectURL(new Blob([data]))
						console.log(objectUrl);
						const link = document.createElement('a')
						link.download = '社区销售数据.xls'
						link.href = objectUrl
						link.click()
			
				}) 
			},
			exportExcelDepart(){
				var selGroupTally = this.selGroupTally;
				var accountSetsId = this.User.accountSetsId;

				if(selGroupTally.startTime=='' || selGroupTally.endTime==''){
					var parmas = {
						accountSetsId:accountSetsId,
						departId:selGroupTally.departId
					};
				}else{
					var parmas = {
						accountSetsId:accountSetsId,
						startTime:selGroupTally.startTime,
						endTime:selGroupTally.endTime,
						departId:selGroupTally.departId
					};
				};	
				this.$api.exportExcel.summaryDataGroup(parmas).then(data => { 
						let objectUrl = window.URL.createObjectURL(new Blob([data]))
						console.log(objectUrl);
						const link = document.createElement('a')
						link.download = '部门销售数据.xls'
						link.href = objectUrl
						link.click()
			
				}) 
			},
			exportExcelPerson(){
				var PersonTally = this.PersonTally;

				var summaryPersonparmas = this.summaryPersonparmas;

				var accountSetsId = this.User.accountSetsId;

				if(PersonTally.startTime=='' || PersonTally.endTime==''){
					var parmas = {
						accountSetsId:accountSetsId,
						accountType:1,
						departId:PersonTally.departId,
						current:summaryPersonparmas.current,
						size:summaryPersonparmas.size
					};
				}else{
					var parmas = {
						accountSetsId:accountSetsId,
						accountType:1,
						startTime:PersonTally.startTime,
						endTime:PersonTally.endTime,
						departId:PersonTally.departId,
						current:summaryPersonparmas.current,
						size:summaryPersonparmas.size
					};
				};
				this.$api.exportExcel.summaryDataPerson(parmas).then(data => { 
					let objectUrl = window.URL.createObjectURL(new Blob([data]))
					console.log(objectUrl);
					const link = document.createElement('a')
					link.download = '部门销售数据.xls'
					link.href = objectUrl
					link.click()
			
				}) 		
 
			}
		},
		mounted() { 
			this.tabShow=this.User.accountSets.accountType;
			if(this.User.accountSets.accountType==2){
				//按社区
				this.gosearchCommunity(); 
				this.datakey=1;
			}else if (this.User.accountSets.accountType==1){
				this.datakey=2;
				this.getdepartment();
				this.gosearch();
			}else if (this.User.accountSets.accountType==4){
				this.datakey=4;
				this.goSearchStore();
			}
		}
	}
</script>

<style  type="css/style">
.ant-spin-container ul{
	text-align: center;
	float: none;
}
/* .ant-table-pagination {
	text-align: center;
	float: none;
}
.ant-pagination{
	text-align: center;
	float: none;
} */
</style>

<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		border-radius: 5px;
		text-align: center;
		font-size: 20px;
		color: #000;
	}

	.period {
		border-radius: 3px;
		text-align: center;
		line-height: 54px;
		border: 1px solid @primary-color;
		white-space: nowrap;
		overflow: hidden;
		box-sizing: border-box;
		height: 80px;

		&:hover {
			cursor: pointer;
			box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
		}

		.month-header {
			height: 25px;
			margin: -8px -8px 0 -8px;
		}

		&.completed {
			.month-header {
				background-color: @gray1-color !important;
				line-height: 20px;
			}

			border-color: @gray1-color;

			color: #a2a2a2;

			&:hover {
				cursor: default;
				box-shadow: none;
			}
		}

		&.disable {
			opacity: 0.4;

			&:hover {
				cursor: default;
				box-shadow: none;
			}
		}
	}

	.h-panel-bar{display:flex; justify-content: space-between;}

	.tabsbox{ font-weight: normal; padding-top: 20px;}

	.tabsbox .ant-tabs-nav-scroll{ text-align: center !important;}

	.databox{ overflow: hidden; padding-top: 30px; padding-bottom: 20px; padding-left: 20px;}
	.databox dl{ float: left; padding-right: 100px;}
	.databox dl dt{ font-size: 18px; color:#2D2D2D}
	.databox dl dd{ font-size: 34px; color: #3667EF;}

	.tablebox{ padding-top: 20px; min-height: 500px;}

	.timeselectbox{ padding:10px;}
	.timeselectbox span{ padding:10px 20px; margin-right:10px; margin-left:10px; background:#eee; cursor:pointer;}
	.timeselectbox span.active{ background:#3667EF;color:#fff;}


	.filterbox {
	padding-top: 20px;
	display: flex;
	justify-content: left;
	align-items: center;
	min-width: 1600px;
	}

	.filterbox .filtertimebox {
		padding-right: 20px;
	}


</style>
